import { Box, Button } from '@mui/material'
import ReactJson from '@uiw/react-json-view'
import * as React from 'react'

interface ICollapsableParams {
  json: object
  title: string
  disabled?: boolean
  extraButtons?: React.ReactNode
  collapsed?: boolean
}

export function CollapsableJson({
  json,
  title,
  extraButtons,
  collapsed = true,
}: ICollapsableParams) {
  const [isCollapsed, setCollapsed] = React.useState(collapsed)
  if (!json) return null
  return (
    <Box>
      <Box>{title}</Box>
      <Box>
        <Button onClick={() => setCollapsed((c) => !c)}>Collapse/Expand</Button>
        {extraButtons}
      </Box>
      <ReactJson value={json} keyName="root" collapsed={isCollapsed} />
    </Box>
  )
}
